var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { builderAdapter, LineUp as LineUpImpl, } from 'lineupjs';
import * as React from 'react';
import { LineUpColumnDesc } from './column';
import LineUpRanking from './LineUpRanking';
import { filterChildrenProps } from './utils';
var LineUp = /** @class */ (function (_super) {
    __extends(LineUp, _super);
    function LineUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.node = null;
        _this.adapter = new builderAdapter.Adapter({
            props: function () { return _this.props; },
            createInstance: function (data, options) {
                return _this.createInstance(_this.node, data, options);
            },
            columnDescs: function (data) {
                return filterChildrenProps(_this.props.children, LineUpColumnDesc).map(function (d) {
                    return d.type.build(d.props, data);
                });
            },
            rankingBuilders: function () {
                return filterChildrenProps(_this.props.children, LineUpRanking).map(function (d) { return LineUpRanking.merge(d.props); });
            },
        });
        return _this;
    }
    LineUp.prototype.createInstance = function (node, data, options) {
        return new LineUpImpl(node, data, options);
    };
    LineUp.prototype.componentDidMount = function () {
        this.adapter.componentDidMount();
    };
    LineUp.prototype.componentDidUpdate = function (prevProps) {
        var props = this.props;
        this.adapter.componentDidUpdate(function (key) { return !builderAdapter.equal(props[key], prevProps[key]); });
    };
    LineUp.prototype.componentWillUnmount = function () {
        this.adapter.componentWillUnmount();
    };
    LineUp.prototype.render = function () {
        var _this = this;
        var className = this.props.className ? "lu-wrapper ".concat(this.props.className) : 'lu-wrapper';
        return (React.createElement("div", { className: className, style: this.props.style || {} },
            React.createElement("div", { ref: function (d) { return (_this.node = d); } })));
    };
    return LineUp;
}(React.PureComponent));
export { LineUp };
//# sourceMappingURL=LineUp.js.map